(function () {
  'use strict';
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const config = JSON.parse(root.querySelector('[data-white-catalog]').textContent);
    const products = config.products;
    const controls = Object.fromEntries([...root.querySelectorAll('[data-choice]')].map(el => [el.dataset.choice, el]));
    const button = root.querySelector('[data-add]');
    const message = root.querySelector('[data-message]');
    const cartLink = root.querySelector('[data-cart-link]');
    const map = window.PMSWhiteBundleMap;
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:config.currency}).format(cents / 100);
    let generation = 0, resolved = null, busy = false, lastDetailsButton = null, tieDetails = null;
    const route = window.Shopify?.routes?.root || '/';
    const urlFor = path => new URL(route + path, location.origin);
    const say = text => { message.textContent = text; };
    if (!map || Object.values(products).some(p => !p || !p.variants.length)) {
      say('This package is temporarily unavailable. Please contact us for help, or shop the individual items below.');
      button.textContent = 'Package unavailable';
      return;
    }
    const option = (value, label, disabled = false) => new Option(label, value, false, false);
    function populate(select, values, placeholder) {
      const previous = select.value;
      select.replaceChildren(option('', placeholder));
      for (const value of values) {
        const item = option(value.id, value.title + (value.available === false ? ' — sold out' : ''));
        item.disabled = value.available === false;
        select.append(item);
      }
      if ([...select.options].some(o => o.value === previous && !o.disabled)) select.value = previous;
    }
    const waistIndex = products.pants.options.findIndex(name => /waist/i.test(name));
    const fitIndex = products.pants.options.findIndex(name => /^fit$/i.test(name));
    if (waistIndex < 0 || fitIndex < 0) { say('Please contact us to choose your pant size.'); return; }
    const waists = [...new Set(products.pants.variants.map(v => v.options[waistIndex]))];
    populate(controls.waist, waists.map(value => ({id:value,title:value})), 'Choose waist size');
    populate(controls.tie, products.tie.variants, 'Choose tie style');
    populate(controls.belt, products.belt.variants, 'Choose belt size');
    function refreshFits() {
      const matches = products.pants.variants.filter(v => v.options[waistIndex] === controls.waist.value);
      populate(controls.fit, matches.map(v => ({id:v.options[fitIndex],title:v.options[fitIndex],available:v.available})), 'Choose fit');
      controls.fit.disabled = !controls.waist.value;
      root.querySelector('[data-pants-status]').textContent = matches.length && !matches.some(v => v.available) ? 'This waist size is currently sold out. Please contact us for help.' : '';
    }
    function choices() {
      return {
        pants: products.pants.variants.find(v => v.options[waistIndex] === controls.waist.value && v.options[fitIndex] === controls.fit.value),
        tie: products.tie.variants.find(v => String(v.id) === controls.tie.value),
        belt: products.belt.variants.find(v => String(v.id) === controls.belt.value),
        socks: products.socks.variants[0], bag: products.bag.variants[0]
      };
    }
    function expectedVariant(selected) {
      if (!selected.pants || !selected.tie || !selected.belt) return null;
      return map.variants[`${selected.pants.id}|${selected.tie.id}|${selected.belt.id}`] || null;
    }
    function showSummary(selected) {
      const rows = [
        'White pants — ' + (selected.pants?.title || 'choose your size & fit'),
        'Washable tie — ' + (selected.tie?.title || 'choose a style'),
        'White web belt — ' + (selected.belt?.title || 'choose a size'),
        'White socks · 1 pair', 'Temple / baptismal bag · 1'
      ];
      root.querySelector('[data-summary]').replaceChildren(...rows.map(text => {const li=document.createElement('li');li.textContent=text;return li;}));
      const photo = root.querySelector('[data-tie-image]');
      const preview = root.querySelector('[data-tie-preview]');
      const src = selected.tie?.image || products.tie.featuredImage;
      photo.hidden = !src;
      if (preview) {
        preview.hidden = !src;
        preview.setAttribute('aria-label', selected.tie ? `View ${selected.tie.title} white tie close-up` : 'View washable white tie close-up');
      }
      if (src) { photo.src = src; photo.alt = selected.tie ? `White tie — ${selected.tie.title}` : 'Washable white tie'; }
    }
    async function checkVariant(id) {
      const url = urlFor(`products/${map.handle}`);
      url.searchParams.set('view', 'pms-white-variant');
      url.searchParams.set('variant', id);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      // Request the Liquid view; application/json makes Shopify bypass it for the product feed.
      const response = await fetch(url, {headers:{Accept:'text/html'},cache:'no-store',signal:AbortSignal.timeout(15000)});
      if (!response.ok) throw new Error('We couldn’t check this package right now. Please try your selection again.');
      const data = await response.json();
      if (String(data.productId) !== String(map.productId) || String(data.variant?.id) !== String(id) || data.currency !== config.currency || !Number.isInteger(data.variant.price)) throw new Error('This package needs a quick check from our team. Please contact us for help.');
      return data.variant;
    }
    async function update() {
      const current = ++generation;
      resolved = null;
      button.disabled = true;
      cartLink.hidden = true;
      button.textContent = 'Choose your options';
      say('');
      const selected = choices();
      showSummary(selected);
      const id = expectedVariant(selected);
      if (!id) {
        if (selected.pants && selected.tie && selected.belt) say('This combination isn’t currently offered as a package. Please contact us for help.');
        return;
      }
      if (Object.values(selected).some(v => !v.available)) { button.textContent='Currently unavailable'; say('One of the included pieces is sold out. Please choose another option or contact us.'); return; }
      if (!config.bundleAvailable) { button.textContent='Package coming soon'; say('Package checkout is being prepared. You can shop the individual items below.'); return; }
      button.textContent = 'Checking your package…';
      try {
        const variant = await checkVariant(id);
        if (current !== generation || busy) return;
        if (!variant.available) { button.textContent='Currently unavailable'; say('This combination is currently sold out. Please choose another option or contact us.'); return; }
        resolved = variant;
        root.querySelector('[data-bundle-price]').textContent = money(variant.price);
        const retail = Object.values(selected).reduce((sum,v)=>sum+v.price,0);
        root.querySelector('[data-bundle-saving]').textContent = retail > variant.price ? `Save ${money(retail-variant.price)} compared with buying these five pieces separately.` : '';
        button.textContent = 'Add package to cart';
        button.disabled = false;
      } catch (error) {
        if (current !== generation) return;
        button.textContent = 'Try checking again';
        button.disabled = false;
        say(error.message || 'Please try again in a moment.');
      }
    }
    root.addEventListener('change', event => {
      if (!event.target.matches('[data-choice]') || busy) return;
      if (event.target === controls.waist) refreshFits();
      update();
    });
    button.addEventListener('click', async () => {
      if (busy) return;
      if (!resolved) { update(); return; }
      const selected = choices();
      if (String(expectedVariant(selected)) !== String(resolved.id)) { update(); return; }
      busy = true;
      generation++;
      button.disabled = true;
      Object.values(controls).forEach(el => {el.disabled=true;});
      button.textContent = 'Adding your package…';
      say('');
      try {
        const latest = await checkVariant(resolved.id);
        if (!latest.available) throw new Error('This combination just sold out. Please choose another option.');
        if (latest.price !== resolved.price) throw new Error('The package price has changed. Please review the updated price before adding it.');
        const properties = { '_pms_white_bundle': 'v1', 'Package': 'White Baptismal / Temple Package', 'Pants':selected.pants.title, 'Tie style':selected.tie.title, 'Belt size':selected.belt.title, 'Included':'White socks (1 pair) + temple/baptismal bag (1)', 'Pants supplied':'Unhemmed' };
        const response = await fetch(urlFor('cart/add.js'), {method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:resolved.id,quantity:1,properties}]}),signal:AbortSignal.timeout(20000)});
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Shopify couldn’t add this package. Please check your cart before trying again.');
        location.assign(urlFor('cart'));
      } catch (error) {
        say(`${error.message || 'The connection was interrupted.'} Check your cart before retrying if you’re unsure whether it was added.`);
        cartLink.hidden = false;
        button.textContent = 'Check package again';
        button.disabled = false;
        resolved = null;
        busy = false;
        Object.values(controls).forEach(el => {el.disabled=false;});
        refreshFits();
      }
    });
    const dialog = root.querySelector('[data-details-dialog]');
    function closeDetails() { dialog.close(); lastDetailsButton?.focus(); }
    root.querySelector('[data-close]').addEventListener('click', closeDetails);
    dialog.addEventListener('click', event => { if(event.target===dialog) {const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom) closeDetails();} });
    function safeDescription(html) {
      const template = document.createElement('template'); template.innerHTML=html || '';
      template.content.querySelectorAll('script,style,iframe,object,embed,form').forEach(el=>el.remove());
      template.content.querySelectorAll('*').forEach(el=>{for(const a of [...el.attributes]) if(/^on/i.test(a.name)||(/^(href|src)$/i.test(a.name)&&! /^(https?:|\/|#)/i.test(a.value))) el.removeAttribute(a.name);});
      return template.content;
    }
    root.querySelectorAll('[data-details]').forEach(trigger=>trigger.addEventListener('click',()=>{
      const role = trigger.dataset.details, product = products[role], selected = choices()[role];
      if (role === 'tie' && window.PMSProductDetails) {
        if (!tieDetails) tieDetails = new window.PMSProductDetails(document.body);
        tieDetails.open(product, selected, trigger);
        return;
      }
      lastDetailsButton = trigger;
      root.querySelector('[data-detail-title]').textContent=product.title;
      const body=root.querySelector('[data-detail-body]');body.replaceChildren();
      const src=role==='bag' && config.bagPhoto ? config.bagPhoto : selected?.image || product.featuredImage;
      if(src){const img=new Image();img.src=src;img.alt=product.title+(selected&&selected.title!=='Default Title'?` — ${selected.title}`:'');body.append(img);}
      root.querySelector('[data-detail-description]').replaceChildren(safeDescription(config.descriptions[role]));
      if(role==='bag' && config.bagPhoto) {const note=document.createElement('p');note.textContent='The bag is included in your package. In this styled photo, the pants and tie show other pieces available in the set.';root.querySelector('[data-detail-description]').append(note);}
      const link=root.querySelector('[data-detail-product]');const url=urlFor(`products/${product.handle}`);if(selected)url.searchParams.set('variant',selected.id);link.href=url.href;
      dialog.showModal();root.querySelector('[data-close]').focus();
    }));
    function unloadDetails(event) {
      if (!event.target.contains(root)) return;
      tieDetails?.destroy();
      document.removeEventListener('shopify:section:unload', unloadDetails);
    }
    document.addEventListener('shopify:section:unload', unloadDetails);
    if (config.currency === 'USD') root.querySelector('[data-bundle-saving]').textContent = 'Five essentials for $79.99.';
    else root.querySelector('[data-bundle-price]').textContent = 'Choose your options';
    refreshFits(); update();
  }
  function boot(scope) {scope.querySelectorAll('[data-pms-white]').forEach(root=>{try{init(root);}catch(error){const message=root.querySelector('[data-message]');if(message)message.textContent='The package builder could not load. Please refresh or contact us for help.';console.error('[White clothing]',error);}});}
  boot(document);
  document.addEventListener('shopify:section:load',event=>boot(event.target));
})();
